module.exports = __webpack_public_path__ + "img/title.7dddc1cd.png";